import { useContext } from "react";
import { FluentContext } from "./context";
export const useLocalization = () => {
    const l10n = useContext(FluentContext);
    return { l10n };
};
